import { create } from "zustand";

export interface MobileAppLaunchStore {
  showDialog: boolean;
  setShowDialog: (showDialog: boolean) => void;
  appName: string;
  setAppName: (appName: string) => void;
  appIcon: string;
  setAppIcon: (appIcon: string) => void;
  appIconColor: string;
  setAppIconColor: (appIconColor: string) => void;
  appDescription: string;
  setAppDescription: (appDescription: string) => void;
  appDownloadUrl: string;
  setAppDownloadUrl: (appDownloadUrl: string) => void;
}

export const useMobileAppLaunchStore = create<MobileAppLaunchStore>((set) => ({
  showDialog: false,
  setShowDialog: (showDialog) => set(() => ({ showDialog })),
  appName: "",
  setAppName: (appName) => set(() => ({ appName })),
  appIcon: "",
  setAppIcon: (appIcon) => set(() => ({ appIcon })),
  appIconColor: "",
  setAppIconColor: (appIconColor) => set(() => ({ appIconColor })),
  appDescription: "",
  setAppDescription: (appDescription) => set(() => ({ appDescription })),
  appDownloadUrl: "",
  setAppDownloadUrl: (appDownloadUrl) => set(() => ({ appDownloadUrl })),
}));
